module.exports = __webpack_public_path__ + "static/media/cytus-glow.dcb5e908.png";